import MainSwiperSlideItem from "./MainSwiperSlideItem";

export default MainSwiperSlideItem;
